module.exports = __webpack_public_path__ + "img/img-intro.cc64fae9.png";